var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactAvatarEditor from 'react-avatar-editor';
import { Avatar } from './Avatar';
import { useDebounce } from '../../hooks/useDebounce';
import { Button } from '../button/Button';
import classNames from 'classnames';
import { acDelete, acPencil } from 'ac-icon';
import { FormFeedback } from '../form/common/FormFeedback';
const AVATAR_INPUT_ID = 'avatar-file-input';
const AvatarEditor = ({ onImageChange, imageUrl, accept, className, id, height, width, canvasWidth, canvasHeight, avatarClassName, debounceTime, disabled, onSave, onDelete, }) => {
    const [file, setFile] = useState(null);
    const [scale, setScale] = useState(1);
    const [error, setError] = useState(null);
    const [isEdit, setIsEdit] = useState(!imageUrl);
    const [localCanvasElement, setLocalCanvasElement] = useState(null);
    const debouncedOnChange = useDebounce(localCanvasElement, debounceTime ? debounceTime : 300);
    let editorRef = useRef();
    const handleChange = () => {
        let fileInput = document.getElementById(id ? id : AVATAR_INPUT_ID);
        if (fileInput.files.length) {
            const newFile = fileInput.files[0];
            if (newFile && newFile.size > 3000000) {
                setError('Слишком большой размер файла');
            }
            else if (newFile &&
                !(newFile.type === 'image/png' || newFile.type === 'image/jpg' || newFile.type === 'image/jpeg')) {
                setError('Формат не поддерживается');
            }
            else {
                setError(null);
            }
            setFile(newFile);
        }
    };
    const imageChange = useCallback(() => {
        const canvasScaled = editorRef.current.getImageScaledToCanvas();
        setLocalCanvasElement(canvasScaled);
    }, []);
    useEffect(() => {
        if (debouncedOnChange && localCanvasElement) {
            debouncedOnChange.toBlob(onImageChange);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedOnChange]);
    const renderButtonEdit = () => {
        return (React.createElement("label", { htmlFor: id ? id : AVATAR_INPUT_ID, onClick: (event) => {
                var _a;
                if ((event === null || event === void 0 ? void 0 : event.target) !== (event === null || event === void 0 ? void 0 : event.currentTarget)) {
                    (_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.click();
                }
                event.stopPropagation();
            }, className: 'avatar-label' },
            React.createElement(Button, { size: 'sm', style: 'ghost', iconPath: acPencil, onClick: () => { }, iconPosition: 'left', className: 'w-100 mb-x2' }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"),
            React.createElement("input", { id: id ? id : AVATAR_INPUT_ID, type: 'file', className: 'visually-hidden', onChange: () => {
                    handleChange();
                    setIsEdit(true);
                }, accept: accept ? accept : 'image/png,image/jpg,image/jpeg' })));
    };
    const css = classNames('avatar-editor', className);
    const cssRAE = classNames('photo-avatar-editor', {
        placeholder: !file,
    }, avatarClassName);
    return (React.createElement("div", { className: css },
        imageUrl && !isEdit ? (React.createElement("div", { className: 'w-100' },
            React.createElement(Avatar, { size: 'xxl', className: 'mb-x4', imageUrl: imageUrl }),
            React.createElement(Button, { size: 'sm', style: 'outline', iconPath: acDelete, iconPosition: 'left', className: 'w-100 mb-x2', onClick: () => {
                    onDelete(() => {
                        setIsEdit(true);
                    });
                } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
            renderButtonEdit(),
            React.createElement("p", { className: 'avatar-editor-sign' }, "\u043D\u0435 \u0431\u043E\u043B\u0435\u0435 1 \u043C\u0431, \u0444\u043E\u0440\u043C\u0430\u0442\u043E\u0432: jpeg, jpg, png"))) : (React.createElement(ReactAvatarEditor, { className: cssRAE, ref: editorRef, image: file, disableHiDPIScaling: true, width: canvasWidth ? canvasWidth : 512, height: canvasHeight ? canvasHeight : 512, scale: scale, border: 0, color: file && isEdit ? [243, 246, 249, 0.7] : [255, 255, 255, 0], borderRadius: file && isEdit ? (canvasHeight ? canvasHeight / 2 : 256) : 0, style: {
                width: width ? width : 176,
                height: height ? height : 176,
            }, onImageReady: () => {
                if (file) {
                    imageChange();
                }
            }, onImageChange: () => {
                if (file) {
                    imageChange();
                }
            } })),
        file && (React.createElement("div", { className: 'w-100' },
            !error && (React.createElement("input", { className: 'input-slider mb-x7', type: 'range', min: 1, max: 3, step: 0.1, value: scale, onChange: (evt) => {
                    setScale(parseFloat(evt.target.value));
                } })),
            React.createElement("div", null,
                error ? (renderButtonEdit()) : (React.createElement(Button, { size: 'sm', className: 'w-100 mb-x2', disabled: disabled, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield onSave(() => {
                            setLocalCanvasElement(null);
                            setError(null);
                            setFile(null);
                            setIsEdit(false);
                        });
                    }) }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
                React.createElement(Button, { size: 'sm', style: 'ghost', className: 'w-100', onClick: () => {
                        setError(null);
                        setLocalCanvasElement(null);
                        onImageChange(null);
                        setFile(null);
                        setIsEdit(!imageUrl);
                    } }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C")))),
        !!error && React.createElement(FormFeedback, { message: error, isShow: true, type: 'danger', className: 'mt-x2 mb-x2' }),
        ((!file && isEdit) || error) && (React.createElement(React.Fragment, null,
            !error && renderButtonEdit(),
            React.createElement("p", { className: 'avatar-editor-sign' }, "\u043D\u0435 \u0431\u043E\u043B\u0435\u0435 3 \u043C\u0431, \u0444\u043E\u0440\u043C\u0430\u0442\u043E\u0432: jpeg, jpg, png")))));
};
export { AvatarEditor };
//# sourceMappingURL=AvatarEditor.js.map